<template>
  <div>
    <div v-if="error != ''" class="p-4">
      <ErrorMessage :message="error" />
    </div>
    <div v-else class="w-100">
      <div class="w-100 py-3 px-4 fit-to-screen bg-page-db border-semi-grey">
        <div class="w-100">
          <div class="row">
            <div class="col-1 align-self-center" @click="pageTo('member')">
              <div class="d-inline-grid cursor-pointer">
                <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 7.875H4.30875L10.5975 1.58625L9 0L0 9L9 18L10.5862 16.4138L4.30875 10.125H18V7.875Z" fill="#222"/>
                </svg>
              </div>
            </div>
            <div class="col-9 align-self-center">
              <p class="mb-0 body-1-2">Point History</p>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <template v-if="is_load">
            <div class="p-3 box-shadow-light-aff bg-white radius-6 mb-3 border-semi-grey" v-for="i in 3">
              <div class="row no-gutters">
                <div class="col-1 align-self-center">
                  <b-skeleton width="100%" height="34px"></b-skeleton>
                </div>
                <div class="col-9 align-self-center">
                  <div class="pl-3">
                    <b-skeleton class="mb-1" width="50%" height="21px"></b-skeleton>
                    <b-skeleton width="30%" height="18px"></b-skeleton>
                  </div>
                </div>
                <div class="col-2 align-self-center">
                  <div class="d-table w-50 ml-auto">
                    <b-skeleton width="100%" height="24px"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="p-3 box-shadow-light-aff bg-white radius-6 mb-3 border-semi-grey" v-for="item in data">
              <div class="row slim-grid-row mb-3">
                <div class="col-6">
                  <p class="m-0 body-3-1">{{ formatDateCalendar(item.date) }}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="m-0 overline" v-if="item.reference.invoice != ''">{{ item.reference.invoice }}</p>
                  <p 
                    class="mb-0 text-14 font-lato" 
                    v-else 
                    :class="{
                      'text-danger' : item.type == 'DECREASE',
                      'text-success' : item.type == 'INCREASE',
                      'text-dark' : item.type == 'KEEP'
                    }">{{ `${item.type == 'DECREASE' ? '-': item.type == 'INCREASE' ? '+' : ''}${item.point}` }}</p>
                </div>
              </div>
              <div class="row slim-grid-row">
                <div :class="item.reference.invoice != '' ? 'col-6' : 'col-12'">
                  <p class="m-0 body-1-4">{{ item.reference.label }}</p>
                </div>
                <div class="col-6 text-right" v-if="item.reference.invoice != ''">
                  <p 
                    class="mb-0 text-14 font-lato" 
                    :class="{
                      'text-danger' : item.type == 'DECREASE',
                      'text-success' : item.type == 'INCREASE',
                      'text-dark' : item.type == 'KEEP'
                    }">{{ `${item.type == 'DECREASE' ? '-': item.type == 'INCREASE' ? '+' : ''}${item.point}` }}</p>
                </div>
              </div>
            </div>
            <div class="w-100 mt-4 text-center" v-if="pagination.last_page > 1">
              <b-pagination
                class="d-inline-block"
                v-model="pagination.current_page"
                :total-rows="pagination.total"
                :per-page="pagination.per_page"
              ></b-pagination>
            </div>
            
            <!-- <div class="p-3 box-shadow-light-aff bg-white radius-6 mb-3 border-semi-grey" v-for="item in data">
              <div class="row no-gutters">
                <div class="col-1 align-self-center">
                  <img :src="item.module.image_url" width="100%" />
                </div>
                <div class="col-9 align-self-center">
                  <div class="pl-3">
                    <p class="mb-0 body-2-4">{{ item.module.name }}</p>
                    <p class="mb-0 body-3">{{ formatDate(item.date) }}</p>
                  </div>
                </div>
                <div class="col-2 align-self-center text-right">
                  <p class="mb-0 text-14 font-lato" :class="item.type == 'DECREASE' ? 'text-danger' : 'text-success'">{{ `${item.type == 'DECREASE'?'-':'+'}${item.point}` }}</p>
                </div>
              </div>
            </div> -->
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script> 
  import {get} from '@/services/index.js'
  import {mapGetters} from "vuex";
  import moment from 'moment';

  export default {
    data() {
      return {
        is_load: true,
        error: '',
        data: [],
        pagination: {
          per_page: 20,
	        total: 0,
	        current_page: 1,
	        last_page: 3, 
        }
      }
    },  
    computed:{
      ...mapGetters(['getMerchant','isNotLogin','getCurrentUser']),
      current_page(){
				return this.pagination.current_page
			}
    },
    watch:{
			current_page(){
				this.loadData()
			}
		},
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        this.is_load = true
        this.error = ''
        Promise.all([
          this.loadPointHistory()
        ])
        .catch(err=>this.error=err)
        .finally(()=>{
          setTimeout(()=>{
            this.is_load = false
          },400)
        })
      },
      loadPointHistory(){
        return new Promise((success,fail)=>{
          get("CORE_HOTEL",`guest-profile/${this.getMerchant.id}/point-history`,{
            page_size: this.pagination.per_page,
					  page: this.pagination.current_page
          }).then(response=>{
	        	let res = response.data
	         	if(res.success){
              this.pagination = {
                per_page: res.per_page,
                total: res.total,
                current_page: res.current_page,
                last_page: res.last_page, 
              }
              this.setupData(res.data)
	         		success()
	         	}else{
	         		fail(res.message)
	         	}
	        })
        })
      },
      setupData(data){
        this.data = []

        const getRef = (full_data,index) => {
          let return_data = {
            label: '',
            invoice: ''
          }

          let printLabeConditionally = (point_conversion,tx_history) =>{
            let module = ''
            if(point_conversion.reference == 'GaConciergeTxOrder'){
              let sub_module = tx_history.map(x=>x.module.name)
              let sub_module_unique = [...new Set(sub_module)]
              module = sub_module_unique.length > 1 ? 'concierge' : sub_module_unique[0]
            }else{
              module = 'booking engine'
            }
            return `${point_conversion.formula} Successful transaction ${module}`
          }

          const parsingPointRef = (code) => {
            let ref_list = [
              {code : 'GaHotelTxOrder', label: 'Booking Engine'},
              {code : 'GaConciergeTxOrder', label: 'Upselling'},
              {code : 'GaRestaurantTxOrder', label: 'Restaurant'},
              {code : 'GpPmsReservation', label: 'PMS Reservation'},
              {code : 'GpPosTransaction', label: 'POS Reservation'},
            ]
            let selected_ref = ref_list.find(ref=>ref.code == code)
            return selected_ref ? selected_ref.label : code
          }

          const saveReturnData = (label,invoice) => return_data = { label: label, invoice: invoice }

          let { 
            reference, 
            point_data,
            merchant_membership_point_conversion : point_conversion, 
            guest_profile_tx_history : tx_history,
            guest_profile_reward_history : reward_history 
          } = full_data
          
          if(reference == 'GaHotelGuestProfileTxHistory'){

            if(tx_history.length == 1) saveReturnData(tx_history[0].module.name, tx_history[0].invoice)
            else return_data.label = printLabeConditionally(point_conversion, tx_history)

          } 
          else if(reference == 'GaHotelGuestProfileRewardHistory') saveReturnData(reward_history[0].module.name, reward_history[0].invoice)
          else if(reference == 'PAYMENT'){
            let {invoice, reference : payment_ref	} = point_data.tx_data
            saveReturnData(parsingPointRef(payment_ref), invoice)
          }
          else return_data.label = this.$capitalize(reference)
          
          
          return return_data
        }

        const getType = (number) => Math.sign(Number(number)) == 1 ? 'INCREASE' : Math.sign(Number(number)) == 0 ? 'KEEP' : 'DECREASE'

        const convertToNumber = (value) => {
          let number = parseFloat(value);
          return Number.isInteger(number) ? number : number.toFixed(2);
        }

        data.forEach((item,index)=>{
          let new_data = {
            type: getType(item.point),
            reference: getRef(item,index),
            date: item.created_at,
            point: convertToNumber(item.point),
            full_data: item
          } 
          
          this.data.push(new_data)
        })
      },
      pageTo(page){
        this.$router.push(`/${this.getMerchant.code}/${page}`)
      },
      formatDate(date,is_utc=false){
        if(is_utc) return moment.utc(date).local().format('MMM D, YYYY, hh:mm A')
        return moment(date).format('MMM D, YYYY, hh:mm A')
      },
      formatDateCalendar(date){
        return moment(date).calendar(null,{
            lastDay : '[Yesterday at] HH:mm',
            sameDay : '[Today at] HH:mm',
            sameElse : 'MMM D, YYYY, HH:mm'
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/general/membership/PointHistory.vue